module.exports = __webpack_public_path__ + "static_portal/img/5.6513026f.jpg";